// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-components-orientation-home-index-js": () => import("./../../../src/components/OrientationHome/index.js" /* webpackChunkName: "component---src-components-orientation-home-index-js" */),
  "component---src-components-orientation-index-js": () => import("./../../../src/components/Orientation/index.js" /* webpackChunkName: "component---src-components-orientation-index-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

